import React, { useState } from 'react';
import { Loader2, CheckCircle2 } from 'lucide-react';
import { api } from '../../lib/api';
import { toast } from 'sonner';

const EMPTY = { nombre: '', email: '', empresa: '', telefono: '', plataforma: '', pedidos_mes: '', mensaje: '' };

export function DemoForm() {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nombre.trim() || !form.email.trim() || !form.empresa.trim()) {
      toast.error('Completa nombre, email y tienda para continuar');
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/leads/demo-request', form);
      setSent(true);
    } catch (err) {
      toast.error('No hemos podido enviar tu solicitud. Inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  const inputCls = 'sera-input w-full bg-[#18181B] border border-[#27272A] rounded-xl px-4 py-3 text-white text-sm placeholder-zinc-500 outline-none transition-colors';

  return (
    <section id="demo" data-testid="landing-demo-form-section" className="py-24 md:py-32 px-6">
      <div className="max-w-xl mx-auto text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-black tracking-tighter text-white mb-4">
          ¿Listo para dejar de perder ventas y recuperar tu tiempo?
        </h2>
        <p className="text-zinc-400 leading-relaxed">
          Habla con nuestro equipo para ver cómo Sera se adapta a las necesidades específicas de tu tienda. Sin compromiso.
        </p>
      </div>

      <div className="max-w-xl mx-auto rounded-3xl border border-white/10 bg-[#0F0F11] p-8">
        {sent ? (
          <div data-testid="landing-demo-form-success" className="flex flex-col items-center text-center py-10">
            <CheckCircle2 size={40} className="text-[#00E5FF] mb-4" />
            <h3 className="text-white font-bold text-lg mb-2">¡Gracias, {form.nombre.split(' ')[0]}!</h3>
            <p className="text-zinc-400 text-sm">Hemos recibido tu solicitud. Te contactaremos en menos de 24h para agendar tu demo.</p>
          </div>
        ) : (
          <form data-testid="landing-demo-form" onSubmit={handleSubmit} className="space-y-4">
            <div className="grid sm:grid-cols-2 gap-4">
              <input data-testid="landing-form-nombre" className={inputCls} placeholder="Nombre completo" value={form.nombre} onChange={(e) => set('nombre', e.target.value)} required />
              <input data-testid="landing-form-email" type="email" className={inputCls} placeholder="Email de trabajo" value={form.email} onChange={(e) => set('email', e.target.value)} required />
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <input data-testid="landing-form-empresa" className={inputCls} placeholder="Nombre de la tienda" value={form.empresa} onChange={(e) => set('empresa', e.target.value)} required />
              <input data-testid="landing-form-telefono" type="tel" className={inputCls} placeholder="Teléfono" value={form.telefono} onChange={(e) => set('telefono', e.target.value)} />
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <select data-testid="landing-form-plataforma" className={inputCls} value={form.plataforma} onChange={(e) => set('plataforma', e.target.value)}>
                <option value="">Plataforma</option>
                <option value="Shopify">Shopify</option>
                <option value="PrestaShop">PrestaShop</option>
                <option value="Otra">Otra</option>
              </select>
              <select data-testid="landing-form-pedidos-mes" className={inputCls} value={form.pedidos_mes} onChange={(e) => set('pedidos_mes', e.target.value)}>
                <option value="">Pedidos al mes</option>
                <option value="Menos de 1.000">Menos de 1.000</option>
                <option value="1.000 - 10.000">1.000 - 10.000</option>
                <option value="Más de 10.000">Más de 10.000</option>
              </select>
            </div>
            <textarea data-testid="landing-form-mensaje" className={inputCls} placeholder="¿En qué te podemos ayudar?" rows={3} value={form.mensaje} onChange={(e) => set('mensaje', e.target.value)} />

            <button
              type="submit"
              data-testid="landing-form-submit"
              disabled={loading}
              className="sera-glow-cta w-full rounded-full bg-[#00E5FF] text-black font-semibold py-3.5 flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {loading ? <Loader2 size={16} className="animate-spin" /> : 'Solicitar demo'}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
